import React, { useEffect, useState } from "react";
import TableContext from "../task/TableContext";
import { useEndpointData } from "../../utils/TableUtils";
import UserService, { UserGetListRequest } from "../../services/UserService";

const UserListEndpoint = async () => {
  const result = await UserService.getList(new UserGetListRequest());
  if (result instanceof Error) {
    return result;
  }
  return { list: result.users, result };
};

const UserTableProvider = (props: React.PropsWithChildren<{}>) => {
  const value = useEndpointData(UserListEndpoint);
  const [profile, setProfile] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredList, setFilteredList] = useState<any[]>([]);

  useEffect(() => {
    if (!value.response) return;

    const users = value.response.result.users ?? [];

    let filtered = [...users];

    if (profile && profile !== "AllProfiles") {
      filtered = filtered.filter((x) => UserService.getRole(x) === profile);
    }

    if (searchTerm) {
      filtered = filtered.filter((el) =>
        el.UserEmail.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredList(filtered);
  }, [value.response, profile, searchTerm]);

  if (value.response) {
    value.response.list = filteredList;
  }

  value.applyFilters = ({
    newProfile,
    searchTerm
  }: {
    newProfile?: string;
    searchTerm?: string;
  }) => {
    if (!value.response) return;

    if (newProfile !== undefined) setProfile(newProfile);
    if (searchTerm !== undefined) setSearchTerm(searchTerm);
  };

  return (
    <TableContext.Provider value={value}>
      {props.children}
    </TableContext.Provider>
  );
};

export default UserTableProvider;
